import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';

import { cropConnectApiClient } from '../../../services/cropConnectApiClient';
import { ReportContainer } from './styles';
import { EmbedConfig } from './types';
import { useContextStore } from '../../../stores/storeRoot';
import { buildPowerBiUrl } from '../../../helpers/powerBiUrlBuilder';

const ContractFullfilmentReport: React.FC = () => {
  const [embedConfig, setEmbedConfig] = useState<EmbedConfig | null>(null);
  const [showReport, setShowReport] = useState(false);
  const { activeBpNumber, activeBpNumberCountry } = useContextStore();

  useEffect(() => {
    if (activeBpNumber) {
      cropConnectApiClient
        .getPowerBiReportContractFulfillmentEmbedToken()
        .then((result) => {
          if (result.success && result.data) {
            const { reportId, embedToken } = result.data;
            if (reportId && embedToken) {
              setEmbedConfig({
                reportId,
                type: 'report',
                id: reportId,
                embedUrl: buildPowerBiUrl(reportId, activeBpNumberCountry),
                accessToken: embedToken,
                tokenType: models.TokenType.Embed,
                settings: {
                  panes: {
                    filters: {
                      visible: false,
                    },
                    pageNavigation: {
                      visible: false,
                    },
                  },
                },
              });
              setShowReport(true);
            } else {
              console.error(
                `Missing either reportId or embedToken in response`
              );
            }
          } else {
            console.error(`Error fetching embed token: ${result.error}`);
          }
        })
        .catch(console.error);
    }
  }, [activeBpNumber]);

  return (
    <ReportContainer>
      {showReport && embedConfig?.accessToken && (
        <PowerBIEmbed
          key={embedConfig.accessToken}
          embedConfig={embedConfig}
          cssClassName={'contract-report-container'}
        />
      )}
    </ReportContainer>
  );
};

export default ContractFullfilmentReport;
